import { render } from "./component-payer.vue?vue&type=template&id=3675f078"
import script from "./component-payer.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3675f078"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3675f078', __exports__)) {
    api.reload('3675f078', __exports__)
  }
  
  module.hot.accept("./component-payer.vue?vue&type=template&id=3675f078", () => {
    api.rerender('3675f078', render)
  })

}


export default __exports__